import { useNavigate } from 'react-router-dom';

import { Button } from 'fluxo-ui';
import { BackIcon, DashboardIcon } from 'fluxo-ui/icons';

import { ROUTES } from '../common/constants';

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="relative min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 px-4 overflow-hidden">
            {/* Decorative background */}
            <div
                aria-hidden
                className="absolute inset-0 bg-[radial-gradient(circle,rgba(59,130,246,0.08)_1px,transparent_1px)] bg-[size:24px_24px]"
            />
            <div aria-hidden className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-teal-400/20 dark:bg-teal-600/10 blur-3xl" />
            <div
                aria-hidden
                className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-cyan-400/20 dark:bg-cyan-600/10 blur-3xl"
            />

            <div className="relative max-w-md w-full text-center">
                <div className="mb-8">
                    <h1 className="text-[8rem] sm:text-9xl font-bold leading-none bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent">
                        404
                    </h1>
                    <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 dark:text-white mt-4">Page not found</h2>
                    <p className="text-sm text-slate-500 dark:text-slate-400 mt-3">
                        Sorry, the page you're looking for doesn't exist or has been moved.
                    </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <Button label="Go Back" variant="default" layout="outlined" leftIcon={BackIcon} onClick={() => navigate(-1)} />
                    <Button label="Go to Dashboard" variant="primary" leftIcon={DashboardIcon} onClick={() => navigate(ROUTES.DASHBOARD)} />
                </div>

                <div className="mt-10 pt-8 border-t border-slate-200 dark:border-slate-800">
                    <p className="text-sm text-slate-500 dark:text-slate-400">
                        If you think this is an error, please{' '}
                        <a
                            href="mailto:support@testam.com"
                            className="text-teal-600 hover:text-teal-700 dark:text-teal-400 dark:hover:text-teal-300 font-medium transition-colors"
                        >
                            contact support
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;
